/**
 * @typedef {import("kaplay").KAPLAYCtx} k
 */

import { FOREGROUND_COLOR_HEX } from "../constants"
import { generateStars, makeTransitionComps } from "../utils"


/**
 * @param {k} k 
 * @param {number} score 
 */
export function end(k, score) {


  k.add(makeTransitionComps(k, () => { }, true))

  generateStars(k, 100, k.width(), k.height())

  k.add([
    k.text("Your Score is"),
    k.anchor("center"),
    k.color(FOREGROUND_COLOR_HEX),
    k.pos(k.center()),

  ])

  k.add([
    k.text(score),
    k.anchor("center"),
    k.color(FOREGROUND_COLOR_HEX),
    k.pos(k.center().add(k.vec2(0, 55))),
    k.scale(2)

  ])

}
